module.exports = __webpack_public_path__ + "static/media/nav8.ae705daf.svg";